module.exports = __webpack_public_path__ + "img/Z81_15.dc5a35b6.jpg";